/* Interno 8 Roma — scroll reveals + slow image motion
   Marks elements with .i8-reveal and flips them to .is-in when they enter the viewport,
   staggering siblings. Respects prefers-reduced-motion. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SELECTORS = [
    /* home: our sections */
    '.i8s', '.i8w__head', '.i8w__tile',
    /* theme sections used on the home page */
    '.section__featured-collections .section__head', '.section__featured-collections .card-collection',
    '.section-dual-tiles__block',
    '.section-featured-products .section__head', '.section-featured-products .product-card',
    '.i8-press',
    /* about / journal / collections */
    '.i8-story__intro', '.i8-story__chapter', '.i8-story__band', '.i8-story__family', '.i8-story__close',
    '.i8j__featured', '.i8j__grid-head', '.i8j__card',
    '.i8c__nav', '.template--collection .product-card',
    '.i8d__head', '.i8d__item'
  ];

  function mark() {
    var nodes = [];
    SELECTORS.forEach(function (sel) {
      try { document.querySelectorAll(sel).forEach(function (el) { if (nodes.indexOf(el) < 0) nodes.push(el); }); } catch (e) {}
    });
    nodes.forEach(function (el) {
      if (el.classList.contains('i8-reveal')) return;
      el.classList.add('i8-reveal');
      /* stagger among siblings that are also revealed */
      var i = 0, sib = el.previousElementSibling;
      while (sib) { if (sib.classList.contains('i8-reveal')) i++; sib = sib.previousElementSibling; }
      el.style.setProperty('--i8-delay', Math.min(i, 8) * 90 + 'ms');
    });
    return nodes;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  function run() {
    mark().forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9 && r.bottom > 0) { el.classList.add('is-in'); } else { io.observe(el); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  /* content loaded later (load more, sliders) */
  document.addEventListener('shopify:section:load', run);
  var mo = new MutationObserver(function () { clearTimeout(mo._t); mo._t = setTimeout(run, 120); });
  mo.observe(document.body, { childList: true, subtree: true });
})();
